import { Base } from '../base-component';

import './content-list-stack.component.scss';
import { MediaQueryService } from 'services/media-query.service';

export class ContentListStack extends Base {

	constructor(element){
		super(element)
	}

	init(){};

	bindEvents(){};

}



// WEBPACK FOOTER //
// ./components/content-list-stack/content-list-stack.component.ts